module.exports = __webpack_public_path__ + "static/img/2.b35d46f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.jpg
// module id = Mn6R
// module chunks = 0